/**
 * Build-time deploy metadata, baked into the bundle by Vite from the
 * VITE_DEPLOY_* env vars set in apps/web/Dockerfile during `docker compose
 * build` (deploy.sh exports them as build args). Defaults to "dev" so
 * local `pnpm --filter @lexcrm/web run dev` works without setup.
 */
export const BUILD_DEPLOY_ID =
  (import.meta.env['VITE_DEPLOY_ID'] as string | undefined) ?? 'dev';
export const BUILD_DEPLOY_VERSION =
  (import.meta.env['VITE_DEPLOY_VERSION'] as string | undefined) ?? '0';
export const BUILD_GIT_SHA =
  (import.meta.env['VITE_GIT_SHA'] as string | undefined) ?? '';
export const BUILD_RELEASED_AT =
  (import.meta.env['VITE_RELEASED_AT'] as string | undefined) ?? '';
